import { FAQ_IDS } from "../../data/siteContent";
import { useLocale } from "../../i18n/LocaleProvider";
import { Section } from "../layout/Section";
import { Accordion } from "../ui/Accordion";

export function Faq() {
  const { copy } = useLocale();

  const items = FAQ_IDS.map((id) => copy.faq.items[id]);

  return (
    <Section id="faq" dark title={copy.faq.title}>
      <Accordion items={items} />
    </Section>
  );
}
